$('#guidelines .guidelines-tabs li').on('touchstart click',function(e) {
  // var $this = $(this);
  var $data = $(this).data('nav');
  $('#guidelines .guidelines-tabs').find('li').each(function(i) {
      if($(this).data('nav') === ($data)) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      };
  });
  $('#guidelines .information-detail').each(function(i) {
      console.log(this);
      if($(this).attr('id') === ($data)) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      };
  });
});

$('#faq .guidelines-tabs').find('li').on('touchstart click',function(e) {
  var $this = $(this);
  var $data = $this.data('nav');
  $('#faq .guidelines-tabs').find('li').each(function(i) {
      if($(this).data('nav') === ($data)) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      };
  });
  $('#faq .information-detail').each(function(i) {
      if($(this).attr('id') === ($data)) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      };
  });
});

$('.js-swich-tab').on('touchstart click',function(e) {
  var $this = $(this);
  var $data = $this.data('label');
  $('#guidelines .information-detail').each(function(i) {
      if($(this).attr('id') === ($data)) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      };
  });
  $('#guidelines .guidelines-tabs').find('li').each(function(i) {
      if($(this).attr('data-nav') === ($data)) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      };
  });
});
